// extracted by mini-css-extract-plugin
export default {"contract_card_head":"Contracts_contract_card_head__smtsi","contract_logo":"Contracts_contract_logo__9RntH","arrow_img":"Contracts_arrow_img__gWrcP"};